module.exports = __webpack_public_path__ + "static/img/syn_icon.11add5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/syn_icon.jpg
// module id = 8Qj1
// module chunks = 1